import { Grid, VStack } from "@chakra-ui/react";
import { BillingCard } from "@src/components/modules/projects/detail/Evaluation/Billing";
import { EfficiencyCard } from "@src/components/modules/projects/detail/Evaluation/Efficiency";
import { ProfitCard } from "@src/components/modules/projects/detail/Evaluation/Profit";
import { Summary } from "@src/components/modules/projects/detail/Evaluation/Summary";
import type { ProjectModel } from "@src/components/modules/projects/detail/models";
import type { FC } from "react";

type ProjectEvaluationProps = {
  project: ProjectModel;
};

export const ProjectEvaluation: FC<ProjectEvaluationProps> = ({ project }) => {
  return (
    <VStack>
      <Grid
        gap="4"
        templateColumns={{
          base: "440px 300px 300px",
          md: "2fr 1fr 1fr",
        }}
        overflowX={{ base: "scroll", md: "unset" }}
        w="full"
      >
        <ProfitCard project={project} />
        <BillingCard project={project} />
        <EfficiencyCard project={project} />
      </Grid>
      <Summary project={project} />
    </VStack>
  );
};
